import React from 'react';
import { Navigate } from 'react-router-dom';
import { billingEnabled } from './api';
import { useBillingAccess } from './BillingAccess';

export const hasFeature = (status, feature, enabled = billingEnabled) =>
  !enabled || (status?.service_state === 'active' && status?.capabilities?.[feature] === true);

export function useFeatureAccess() {
  const access = useBillingAccess();
  return feature => hasFeature(access?.status, feature);
}

export function Feature({ name, children }) {
  const allows = useFeatureAccess();
  return allows(name) ? children : null;
}

export function FeatureRoute({ name, children }) {
  const allows = useFeatureAccess();
  return allows(name) ? children : <Navigate to="/" replace />;
}
